var map = {
	"./01 - MIT.svg.png": 560,
	"./02 - Carnegie_Mellon_University.svg.png": 561,
	"./03 - Chicago uni.jpeg": 562,
	"./04 - HEC.png": 563,
	"./05 -northwestern_university-logo.png": 564,
	"./06 - nyu.png": 565,
	"./07 - UoE-logo.jpg": 566,
	"./08 - ManchesterUni.png": 567,
	"./09 - STA.png": 568,
	"./10 -northeastern_university_logo.png": 569,
	"./11 - msu.jpg": 570,
	"./12 - LU.jpg": 571,
	"./13 - UIB.png": 572,
	"./15 - BA.png": 573,
	"./16 - CU.jpg": 574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 559;